<!-- Right Side: Trips Table -->
  <div class="overflow-y-auto mb-2">
    <div *ngIf="false" class="flex justify-end mt-1">
      <!-- Type -->
        <div class="bg-gray-100 dark:bg-zinc-900 p-1 rounded-xl flex shadow-sm">
          <button type="button" (click)="setType('SalesItemLineDetail')" [ngClass]="lineItemType === 'SalesItemLineDetail'
                            ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                            : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
            class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
            Normal
          </button>
          <button (click)="setType('DescriptionOnly')" type="button" [ngClass]="lineItemType === 'DescriptionOnly'
                            ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                            : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
            class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
            Descripion Only
          </button>
        </div>
    </div>
    <!-- Header: Search & Date -->
    <div
      class="p-3 flex flex-wrap items-center gap-3 border-b border-zinc-200 dark:border-zinc-800 sticky top-0 bg-white dark:bg-zinc-950 z-30">
      <div class="relative">
        <input [(ngModel)]="search" (input)="onSearchInput()" type="text" required="" placeholder="Search.."
          class="pl-8 ng-untouched ng-pristine ng-invalid">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"></path>
        </svg>
      </div>
       <div class="space-y-1">
        <div class="flex flex-1 gap-2">
          <div class="flex-1">
            <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date" [readOnly]="true"
              [owlDateTimeTrigger]="date" (ngModelChange)="onDateTimeChange($event)" [selectMode]="'range'"
              class="w-full border rounded-md p-2 text-sm" />
            <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
          </div>
        </div>
      </div>
      <div class="space-y-1 w-48">
        <ng-select placeholder="Select Member" [notFoundText]="'No record found'" [searchable]="true"
          [appendTo]="'body'" [(ngModel)]="selectedMember" (change)="onSelectMember($event)">
          <ng-option value="">Select Member</ng-option>
          <ng-option *ngFor="let member of tripMembers" [value]="member?.id">
            {{member?.displayName | titlecase }}
          </ng-option>
        </ng-select>
      </div>

        <div *ngIf="type === 'fundingsource'" class="space-y-1 w-48">
          <ng-select [(ngModel)]="selectedFundingSource" (change)="onChange()" [clearable]="false"
            [searchable]="true" [notFoundText]="'No record found'" placeholder="Select FS" [appendTo]="'body'">
            <ng-option value="">Select FS</ng-option>
            <ng-option *ngFor="let fundingsource of fundingSources" [value]="fundingsource">{{fundingsource?.title
              | titlecase}}</ng-option>
          </ng-select>
        </div>
        <div *ngIf="type === 'company'">
          <ng-select class="w-full sm:w-44" [(ngModel)]="selectedCompany" (change)="onChange()" [clearable]="false"
            [searchable]="true">
            <ng-option value="">Select Company</ng-option>
            <ng-option *ngFor="let company of companies" [value]="company.id">{{ company?.name | titlecase }}</ng-option>
          </ng-select>
        </div>
         <div *ngIf="filteredTrips && filteredTrips.length" class="flex items-center gap-2">
            <h1 class=" text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (filteredTrips != 50? (50
                -filteredTrips.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
    </div>

    <!-- Scrollable Table -->
    <div class="flex-1 overflow-auto">
      <table class="min-w-full table-auto">
        <thead>
          <tr>
            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              #
            </th>
            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              <input *ngIf="filteredTrips.length" input type="checkbox"
                [checked]="isAllFilteredSelected()"
                (change)="onSelectAllTrips($event)" />
            </th>

            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Action
            </th>

            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Stamps
            </th>

            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Reference
            </th>
            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Miles
            </th>
            <th class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ type === 'company' ? 'Offered Fare' : 'Fare' }}</th>
            <th class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ type === 'company' ? 'Special Fare' : 'Pre Special Fare' }}</th>
            <th class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Cancel Rate</th>
            <th class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">No-Show Rate</th>
            <th class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Payment</th>
              <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Member
            </th>

            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              {{ type === 'company' ? 'Company' : 'Funding Source' }}
            </th>

            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Contact No.
            </th>
            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Pickup Time
            </th>
            <th
              class="sticky top-0  px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Status
            </th>
          </tr>
        </thead>

        <tbody>
          <tr [ngClass]="{'bg-blue-100 dark:bg-blue-900/40': selectedTrips.includes(trip)}"
            class="cursor-pointer hover:bg-gray-950/5 dark:hover:bg-white/10"
            *ngFor="let trip of (filteredTrips | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}); let i = index">
            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{ i + 1 }}
            </td>
            <td
              class="relative px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              <!-- Selected row marker, only show when row is selected. -->
              <div class="absolute inset-y-0 left-0 w-0.5 bg-main-primary" [ngClass]="{'hidden': !trip.isSelected}">
              </div>
              <input [checked]="trip.isSelected" (change)="onSelectTrip(trip)"
               type="checkbox" />
            </td>

            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              <div class="flex items-center justify-center">
                <button [appToolTip]="'Detail'" (click)="opendetailModal(trip)"
                  class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400"><svg
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z">
                    </path>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"></path>
                  </svg>
                </button>
              </div>
            </td>
            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              <div class="flex items-center gap-1">
                <ng-container *ngIf="trip.status == 'cancelled'">
                  <span *ngIf="trip.flags.isBillable"
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FEA405]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FEA405] sm:text-xs/5 forced-colors:outline">
                    Billable </span>
                </ng-container>
              </div>
            </td>
            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{ trip.reference || 'N/A' }}{{trip.suffix ? '-' + trip.suffix : '' }}
            </td>

            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
               {{ trip.miles ? (trip.miles | number:'1.2-2') + ' mi' : '' }}
            </td>
            <ng-container *ngIf="getRates(trip) as r">
              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">${{ r.fare | number:'1.2-2' }}</td>
              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">${{ r.specialRate | number:'1.2-2' }}</td>
              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">${{ r.cancelRate | number:'1.2-2' }}</td>
              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">${{ r.noShowRate | number:'1.2-2' }}</td>
              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">${{ r.payment | number:'1.2-2' }}</td>
            </ng-container>
              
            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{(trip.member?.displayName) | titlecase}}
            </td>
            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              <ng-container *ngIf="type === 'company'">
                {{ (trip.companyDetails?.name || trip.company?.name) | titlecase }}
              </ng-container>
              <ng-container *ngIf="type !== 'company' && preFundingSources && trip.fundingsource">
                {{ (preFundingSources[trip.fundingsource].title) | titlecase }}
              </ng-container>
            </td>

            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap" phoneNumberFormat [phoneNumber]="trip.member?.contactNumber">
              {{ trip.member?.contactNumber || 'N/A' }}
            </td>

            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{ trip.pickup?.time | date: 'MM/DD/YYYY HH:mm' }}
            </td>
            <td
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              <div [ngClass]="{
                'badge-danger': trip?.status === 'cancelled',
                'badge-success': trip?.status === 'completed'
              }">
                {{trip.status | titlecase }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="flex justify-end">
        <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
      </div>
      </div>
  </div>